import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
	"inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-card text-primary hover:bg-primary/80",
				secondary:
					"border-transparent bg-secondary-background text-primary hover:bg-secondary-background/80",
				destructive:
					"border-transparent bg-red-100 text-red-700 hover:bg-red-200",
				outline: "text-foreground",
				success:
					"border-transparent bg-green-100 text-green-700 hover:bg-green-200",
				warning:
					"border-transparent bg-yellow-100 text-yellow-700 hover:bg-yellow-200",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	}
)

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
	VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	)
}

export { Badge, badgeVariants } 